import { render, staticRenderFns } from "./FirmaEntrega.vue?vue&type=template&id=799c6f9a&scoped=true&"
import script from "./FirmaEntrega.vue?vue&type=script&lang=js&"
export * from "./FirmaEntrega.vue?vue&type=script&lang=js&"
import style0 from "./FirmaEntrega.vue?vue&type=style&index=0&id=799c6f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c6f9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
